export const STATI = { programmato: "Programmato", in_corso: "In corso", sospeso: "Sospeso", completato: "Completato" };
export const STATO_STYLE = {
  programmato: "bg-sky-50 text-sky-700 border-sky-200 dark:bg-sky-950/40 dark:text-sky-300",
  in_corso: "bg-orange-50 text-orange-700 border-orange-200 dark:bg-orange-950/40 dark:text-orange-300",
  sospeso: "bg-slate-100 text-slate-600 border-slate-200 dark:bg-slate-800 dark:text-slate-300",
  completato: "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300",
};

const D = (s) => { const [y, m, d] = String(s).slice(0, 10).split("-").map(Number); return new Date(y, m - 1, d); };
export const isoDay = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const todayIso = () => isoDay(new Date());

export const workingDays = (a, b) => {
  if (!a || !b || D(b) < D(a)) return 0;
  let n = 0;
  for (let d = D(a); d <= D(b); d.setDate(d.getDate() + 1)) if (d.getDay() !== 0) n += 1;
  return n;
};

export const endAfter = (a, days) => {
  const d = D(a);
  while (d.getDay() === 0) d.setDate(d.getDate() + 1);
  let left = Math.max(1, days) - 1;
  while (left > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) left -= 1; }
  return isoDay(d);
};

// Anteprima del calcolo (il server ricalcola comunque al salvataggio).
export const plan = (f) => {
  if (!f.data_inizio) return null;
  if (f.calcolo === "libero") {
    const fine = f.data_fine && D(f.data_fine) >= D(f.data_inizio) ? f.data_fine : null;
    if (f.data_fine && !fine) return null;
    const end = fine || String(f.data_inizio).slice(0, 10);
    return { data_fine: end, ore_previste: Number(f.ore_previste) || 0, giorni: workingDays(f.data_inizio, end), perDay: null, libero: true };
  }
  const perDay = Math.max(1, Number(f.num_operai) || 1) * (Number(f.ore_giorno) || 8);
  if (f.calcolo === "ore") {
    const ore = Number(f.ore_previste) || 0;
    if (ore <= 0) return null;
    const fine = endAfter(f.data_inizio, Math.ceil(ore / perDay));
    return { data_fine: fine, ore_previste: ore, giorni: workingDays(f.data_inizio, fine), perDay };
  }
  if (!f.data_fine || D(f.data_fine) < D(f.data_inizio)) return null;
  const giorni = workingDays(f.data_inizio, f.data_fine);
  return { data_fine: f.data_fine, ore_previste: giorni * perDay, giorni, perDay };
};

// Divide il cantiere in blocchi lun–sab per il calendario (domeniche escluse, fine esclusiva).
export const siteSegments = (start, end) => {
  const out = [];
  let seg = null;
  for (let d = D(start); d <= D(end); d.setDate(d.getDate() + 1)) {
    if (d.getDay() === 0) { if (seg) { out.push([seg, isoDay(d)]); seg = null; } }
    else if (!seg) seg = isoDay(d);
  }
  if (seg) { const e = D(end); e.setDate(e.getDate() + 1); out.push([seg, isoDay(e)]); }
  return out;
};

export const fmtDay = (s) => (s ? D(s).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" }) : "—");
